import { API } from "@/lib/api";

export const nsKey = (uid, base) => `vp_assistant_${base}_${uid || "anon"}`;

export function getSession(uid) {
  let s = localStorage.getItem(nsKey(uid, "session"));
  if (!s) {
    s = (crypto.randomUUID && crypto.randomUUID()) || `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(nsKey(uid, "session"), s);
  }
  return s;
}

// Streams an assistant answer over SSE (fetch, so we can send the Bearer token).
// handlers: { onSources(arr), onDelta(text), onError(msg), onDone(logId) }
export async function streamChat({ sessionId, message, handlers = {} }) {
  const token = localStorage.getItem("vp_token");
  const resp = await fetch(`${API}/assistant/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ session_id: sessionId, message }),
  });
  if (!resp.ok || !resp.body) throw new Error("request failed");
  const reader = resp.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let idx;
    while ((idx = buf.indexOf("\n\n")) >= 0) {
      const chunk = buf.slice(0, idx);
      buf = buf.slice(idx + 2);
      if (!chunk.startsWith("data: ")) continue;
      let evt;
      try { evt = JSON.parse(chunk.slice(6)); } catch { continue; }
      if (evt.type === "sources") handlers.onSources?.(evt.sources || []);
      else if (evt.type === "delta") handlers.onDelta?.(evt.text);
      else if (evt.type === "error") handlers.onError?.(evt.message);
      else if (evt.type === "done") handlers.onDone?.(evt.log_id);
    }
  }
}
